import { render, staticRenderFns } from "./SuperAdminReportLayoutIndex.vue?vue&type=template&id=34830e04&scoped=true"
import script from "./SuperAdminReportLayoutIndex.vue?vue&type=script&lang=js"
export * from "./SuperAdminReportLayoutIndex.vue?vue&type=script&lang=js"
import style0 from "./SuperAdminReportLayoutIndex.vue?vue&type=style&index=0&id=34830e04&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34830e04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34830e04')) {
      api.createRecord('34830e04', component.options)
    } else {
      api.reload('34830e04', component.options)
    }
    module.hot.accept("./SuperAdminReportLayoutIndex.vue?vue&type=template&id=34830e04&scoped=true", function () {
      api.rerender('34830e04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/reports/layout/SuperAdminReportLayoutIndex.vue"
export default component.exports